/* eslint-disable */

import Vue from 'vue'
import Component from 'vue-class-component'
import { print } from '../mla-shared';

// Used for conditional rendering on touchscreen and non-touchscreen devices
@Component
export class DetectTouchScreen extends Vue {
  detect() {
    let result = false
    if (window.PointerEvent && ('maxTouchPoints' in navigator)) {
      // if Pointer Events are supported, just check maxTouchPoints
      if (navigator.maxTouchPoints > 0) {
        result = true
      }
    } else {
      // no Pointer Events...
      if (window.matchMedia && window.matchMedia("(any-pointer:coarse)").matches) {
        // check for any-pointer:coarse which mostly means touchscreen
        result = true
      } else if (window.TouchEvent || ('ontouchstart' in window)) {
        // last resort - check for exposed touch events API / event handler
        result = true
      }
    }
    // console.log('Is a touchscreen', result)
    return result
  }
}

// Print page
export const Print = {
  methods: {
    PrintPage () {
      print();
    }
  }
}

// Update service worker
@Component
export class Update extends Vue {
  data() {
    return {
      // refresh variables
      refreshing: false,
      registration: null,
      updateExists: false
    }
  }
  created(this: any) {
    // Listen for our custom event from the SW registration
    document.addEventListener('swUpdated', this.updateAvailable, { once: true })
    // Prevent multiple refreshes
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (this.refreshing) return
      this.refreshing = true
      // Here the actual reload of the page occurs
      window.location.reload()
    })
  }
  // Store the SW registration so we can send it a message
  // We use `updateExists` to control whatever alert, toast, dialog, etc we want to use
  // To alert the user there is an update they need to refresh for
  updateAvailable(this: any, event: any) {
    this.registration = event.detail
    this.updateExists = true
    // Call immediately no user confirmation
    // this.refreshApp()
  }
  // Called when the user accepts the update
  refreshApp(this: any) {
    this.updateExists = false
    // Make sure we only send a 'skip waiting' message if the SW is waiting
    if (!this.registration || !this.registration.waiting) return
    // Send message to SW to skip the waiting and activate the new SW
    this.registration.waiting.postMessage({ type: 'SKIP_WAITING' })
  }
}
